// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SubAttachment general snapshot 1`] = `
<div class="sub-attachment xs-12">
  <div class="image-wrap xs-4 md-3">
    <productinfoimage-stub imagery="[object Object]" primary="backie"></productinfoimage-stub>
  </div>
  <div class="info-wrap xs-8 md-9">
    <div class="xs-10 md-12">
      <p class="semi-bold upper xs-f-xsmall max-at-tweak">Treatment</p>
      <p data-mr-ass="added-to-order-name" class="color-slate xs-f-xsmall max-at-tweak">Pro Boost Shine</p>
      <pill-stub text="SUBSCRIPTION ADD-ON"></pill-stub>
    </div>
    <div class="qty-edit xs-12"><span class="xs-f-xsmall max-at-tweak upper">qty:</span>
      <qtybuttons-stub qty="1" minqty="1" maxqty="9"></qtybuttons-stub>
    </div>
  </div>
  <confirmdialog-stub title="Remove item" text="Your item will be removed from all upcoming shipments. Do you want to continue?" confirmtext="Remove"><button type="button" aria-label="Remove Item" data-mr-ass="remove-xsell-button" class="remove-item transparent-btn xs-f-large max-at-tweak"><span class="icon-x clickable"></span></button></confirmdialog-stub>
</div>
`;
